import React from 'react';
import Heading from '../../components/Typography/Heading/Heading';
import SubHeading from '../../components/Typography/SubHeading/SubHeading';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import { getURLTickers } from '../ProfileScreen/util';
import { navigateToLoginFromChecklist } from './utils';
import config from '../../config';
import styles from './styles.css';
import { redirectToAccountFinder } from '../../flows/shared/utils';

const StepsSection = () => {
  return (
    <>
      <section>
        <div className="checklist-section-title">
          Opening an account takes 5-10 minutes:
        </div>
        <dl>
          <ol>
            <li aria-describedby="basic-investment-info">
              <dt data-name="1">Provide basic investment details</dt>
              <dd id="basic-investment-info">
                This helps us tailor your investment options.
              </dd>
            </li>
            <li aria-describedby="investment-info">
              <dt data-name="2">Choose Mutual Funds for your Rollover IRA</dt>
              <dd id="investment-info">
                <a
                  href="https://www.troweprice.com/personal-investing/tools/fund-research"
                  target="_blank"
                  rel="noopener noreferrer">
                  Research Mutual Funds
                </a>
                {', '}
                <a
                  href={`${config(
                    'returnUrlPrefix'
                  )}personal-investing/new-account/setup/account-info/brk-checklist/rollover-ira`}
                  target="_blank"
                  rel="noopener noreferrer">
                  switch to a Brokerage Rollover IRA account
                </a>
                {', '} or{' '}
                <a
                  href={`${config(
                    'returnUrlPrefix'
                  )}personal-investing/new-account/setup/account-info/brk-checklist/roth-rollover-ira`}
                  target="_blank"
                  rel="noopener noreferrer">
                  switch to a Brokerage Roth Rollover IRA account
                </a>{' '}
                to invest in ETFs, stocks, and other securities.
              </dd>
            </li>
            <li aria-describedby="personal-details-info">
              <dt data-name="3">Provide personal details</dt>
              <dd id="personal-details-info">
                We&apos;ll use these to secure and verify your account.
              </dd>
            </li>
          </ol>
        </dl>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

const ChecklistSection = () => {
  return (
    <>
      <section>
        <div className="checklist-section-title">You will need:</div>
        <ul>
          <li>A minimum of $1,000</li>
          <li>Name of the provider that holds your account</li>
          <li>Name of your former employer</li>
          <li>Your Social Security number</li>
          <li>Permanent U.S. residence information</li>
        </ul>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

const RolloverFootnote = () => {
  return (
    <>
      <section className="">
        <div className="footnote">
          *Consider all available options, which include remaining with your
          current retirement plan, rolling over into a new employer&apos;s plan
          or IRA, or cashing out the account value. When deciding between an
          employer-sponsored plan and IRA, there may be important differences to
          consider, such as range of investment options, fees and expenses,
          availability of services, and distribution rules (including
          differences in applicable taxes and penalties). Depending on your
          plan&apos;s investment options, in some cases, the investment
          management fees associated with your plan&apos;s investment options
          may be lower than similar investment options offered outside the plan.
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

const getSubHeaderText = () => (
  <>
    Consolidate existing 401(k)s into one easy-to-manage IRA with a 401(k)
    Rollover.*
  </>
);

const RolloverChecklistScreen = ({ appState, next }) => {
  const {
    store: { authenticated }
  } = appState;

  // multi-fund buy query check
  // capture tickers to pass to InvestmentReviewScreen
  const multiBuyTickers = getURLTickers(window.location.search);

  return (
    <div className="checklist-screen">
      <Heading text="Open a Rollover IRA account" />
      <SubHeading text={getSubHeaderText()} />

      <div className="qv-row">
        <div className="qv-col col-left">
          <StepsSection />
        </div>

        <div className="qv-col col-right">
          <ChecklistSection />
        </div>
      </div>

      <div className="button-container">
        {authenticated ? (
          <MFBeaconButton
            variant="primary"
            size="normal"
            id="checklistContinueExisting"
            onClick={next(multiBuyTickers)}
            label="Continue Opening an Account"
            data-name="rolloverChecklistContinue"
          />
        ) : (
          <div className="login-buttons">
            <MFBeaconButton
              variant="primary"
              size="normal"
              id="checklistLogin"
              onClick={() => navigateToLoginFromChecklist('/profile')}
              label="Already a Client? Log In to Continue"
              data-name="rolloverChecklistLogin"
            />
            <MFBeaconButton
              variant="secondary"
              size="normal"
              id="checklistContinueNew"
              onClick={next(multiBuyTickers)}
              label="New to T. Rowe Price? Start Now"
              data-name="rolloverChecklistNewStart"
            />
          </div>
        )}
        <MFBeaconButton
          variant="tertiary"
          size="normal"
          id="checklistBack"
          onClick={redirectToAccountFinder}
          label="Back"
        />
      </div>
      <PhoneNumber />
      <RolloverFootnote />
      <style jsx>{styles}</style>
    </div>
  );
};

export default RolloverChecklistScreen;
